import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=bcf16ce4&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=js"
export * from "./ImageView.vue?vue&type=script&lang=js"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=bcf16ce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf16ce4",
  null
  
)

export default component.exports